module.exports = __webpack_public_path__ + "img/stacks.639497e1.svg";